/*
The current client-side config solution is a bit of a hack.
This file is designed to determine what config "file" should
be used based on the context of the call.  Currently, it is
believed that only the hostname posses this information.
Once can override using the `env` query param if necessary.
*/

import { Environment } from './environmentModels';

let theEnvironment: Environment;

function getQueryEnvironment(): Environment | null {
  if (typeof window !== 'undefined') {
    if (window.location && window.location?.search) {
      const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
      const queryEnv: string | null = urlParams.get('env');

      switch (queryEnv) {
        case 'prod':
          return Environment.Prod;
        case 'staging':
          return Environment.Staging;
        case 'local':
          return Environment.Local;
        default:
      }
    }
  }
  return null;
}

function getHostnameEnvironment(): Environment {
  if (typeof window !== 'undefined') {
    const hostname = window.location?.hostname ?? '';
    if (
      hostname.includes('staging.vistaprint') ||
      (hostname.includes('staging.') && hostname.includes('vpsvc.com')) ||
      ((hostname.includes('qa.') || hostname.includes('qa-')) && hostname.includes('vpsvc.com'))
    ) {
      return Environment.Staging;
    }
    if (hostname === 'localhost') {
      return Environment.Local;
    }
  }
  return Environment.Prod;
}

function getClientConfigEnvironment(): Environment {
  const queryEnv = getQueryEnvironment();
  const hostEnv = getHostnameEnvironment();
  return queryEnv ?? hostEnv;
}

const getClientEnvironment = (useCache: boolean = true): Environment => {
  if (!theEnvironment || !useCache) {
    theEnvironment = getClientConfigEnvironment();
  }
  return theEnvironment;
};

export const isProduction = (useCache: boolean = true): boolean => {
  return getClientEnvironment(useCache) === Environment.Prod;
};

export default getClientEnvironment;
